import { Dispatch, SetStateAction, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import useApiCall from '../../../../../hooks/useApiCall';
import useGetGeneralAppData from '../../../../../hooks/useGetGeneralAppData';
import { useQuery } from '../../../../../hooks/useQuery';
import ConsultsService from '../../../../../services/ConsultsService';
import MyModal from '../../../../Modal';
import { ICreateInstructionApiResponse, Rotas, TrajetoInstruc } from '../types';

interface IAbateResultModal {
  abateResultModalShow: boolean;
  setAbateResultModalShow: Dispatch<SetStateAction<boolean>>;
  setIsLoading: Dispatch<SetStateAction<boolean>>;
  setInstructions: Dispatch<SetStateAction<TrajetoInstruc[]>>;
  direction: 'going' | 'returning';
  selectedRoute: Rotas;
  isMultiRoute: boolean;
}

export default function AbateResultModal({
  abateResultModalShow,
  setAbateResultModalShow,
  setIsLoading,
  setInstructions,
  direction,
  selectedRoute,
  isMultiRoute,
}: IAbateResultModal) {
  const { apiCall } = useApiCall();
  const { userCode, userProfile } = useGetGeneralAppData();
  const query = useQuery();
  const companyCode = query.get('codEmpresa');
  const { consultCode } = useParams();

  const abateResult = useCallback(async () => {
    await apiCall({
      apiToCall: ConsultsService.createInstruction,
      reqBody: JSON.stringify({
        codUsu: userCode,
        perfilUsu: userProfile,
        codEmpresa: companyCode,
        codConsulta: consultCode,
        rota: 1,
        sentido: isMultiRoute ? selectedRoute.sentido : direction === 'going' ? 1 : 2,
        trajetoInstrucoes: [
          {
            tipoInstrucao: 3,
            instrucao: 'Transporte Público',
            sequencia: 1,
            origem: '',
            destino: '',
            linhaTransporte: 'TRANSPORTE MANTIDO',
            routeID: '',
            tempo: 30,
            distancia: 2000,
            origemLat: 0,
            origemLng: 0,
            destinoLat: 0,
            destinoLng: 0,
            codGeo: 'MANT',
            codItem: 1758,
            tarifa: 0,
          }
        ]
      }),
      onStartLoad: () => setIsLoading(true),
      onEndLoad: () => setIsLoading(false),
      catchMessage: 'Não foi possível abater. Por favor, tente novamente',
      actionAfterResponse: (response: ICreateInstructionApiResponse) => {
        if (!response.codigo) {
          toast.error(`Não foi possível abater. Por favor, tente novamente (${response.msg})`);
          return;
        }
        setAbateResultModalShow(false);
        toast.success(isMultiRoute ? `O resultado do trecho ${selectedRoute.rota} foi abatido com sucesso. Conclua a roteirização, ou adicione mais instruções!` : `O resultado sentido ${direction === 'going' ? 'ida' : 'volta'} foi abatido com sucesso. Conclua a roteirização, ou adicione mais instruções!`);
        setInstructions(response.trajetoInstrucoes);
      }
    });
  }, [apiCall, userCode, userProfile, companyCode, consultCode, isMultiRoute, selectedRoute?.sentido, selectedRoute?.rota, direction, setIsLoading, setAbateResultModalShow, setInstructions]);

  return (
    <MyModal
      show={abateResultModalShow}
      title={isMultiRoute ? `Abater Resultado (Trecho ${selectedRoute.rota})` : `Abater Resultado (${direction === 'going' ? 'Ida' : 'Volta'})`}
      closeButtonLabel="Fechar"
      actionButtonLabel="Abater"
      onClose={() => setAbateResultModalShow(false)}
      onAction={() => abateResult()}
      // isActionButtonDisabled={!selectedItem.value}
      type="suspendAction"
      size='lg'
      modalBody={(
        <>
          Tem certeza que deseja abater o resultado {isMultiRoute ? `do trecho ${selectedRoute.rota}` : `da ${direction === 'going' ? 'Ida' : 'Volta'}`}?
        </>
      )}
    />
  );
}
